module.exports = __webpack_public_path__ + "img/icon-vk-market.e5a167a2.svg";